import warning from './warning';
export default (function (component) {
  return warning(false, component, "The legacy component has been deprecated, and ant design 4.0 now released! Please follow https://ant.design/components/".concat(component.toLowerCase()).concat(component === 'Mention' ? 's' : '', " to upgrade."));
});


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@ant-design_compatible@1.0.2@@ant-design/compatible/es/_util/upgradeMessage.js
// module id = 160
// module chunks = 0